export default __webpack_public_path__ + "static/media/etihadLoaderLogo.3a734700.svg";